<template>
  <div class="d-flex flex-column align-items-center">
    <personal-user v-model="user" :disableEmail="true" style="width: 40em;"/>
    <btn-action class="btn btn-primary" @click="save" >Сохранить</btn-action>
  </div>
</template>

<script>
  import PersonalUser from '../../components/personal/user.vue'
  import BtnAction from '../../components/btn-action'
  import api from '@/api'
  import {pick} from 'lodash'

  export default {
    components: {
      BtnAction,
      PersonalUser},
    data () {
      return {}
    },
    methods: {
      save () {
        return this.$validator.validateAll().then(success => {
          if (success) {
            return api.put(`users/${this.$root.user.id}`, this.user)
              .then(() => {
                this.$root.user = Object.assign(this.$root.user, this.user)
              })
          }
        })
      },
    },
    computed: {
      user () {
        return pick(this.$root.user, ['first_name', 'second_name', 'third_name', 'email', 'phone'])
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/personal/index.vue